import React, { createContext, useContext, useEffect, useState } from "react";
import EngagementHeader from "./EngagementHeader";
import EngagementContent from "./EngagementContent";
import { isEmpty } from "lodash";
import { CustomerProps } from "./ShowCustomer";
export const ActiveEngagement = createContext(null);

function ShowEngagement({
}) {

  
  const [activeEngagement , setActiveEngagement] = useState(null);
  const [engagementData, setActiveEngagamentData] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const {isCaseManagement, customer} = useContext(CustomerProps);


 const passValue = {
    activeEngagement:activeEngagement,
    setActiveEngagement: setActiveEngagement,
    engagementData: engagementData,
    setActiveEngagamentData: setActiveEngagamentData
  }

  return (
    customer &&
    !isEmpty(customer) && (
      <ActiveEngagement.Provider value={passValue} >
        <div style={{ height: "100%" }} key={customer}>
          <EngagementHeader />
          <div
            style={{
              height: isCaseManagement ? "67vh" : "100%",
              overflow: "scroll",
            }}
            className="scrollable-container"
          >
            <EngagementContent activeTab={activeTab} setActiveTab={setActiveTab} />
          </div>
        </div>
      </ActiveEngagement.Provider>
    )
  );
}

export default ShowEngagement;
